exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-title[data-v-35a0cdf7]{font-size:14px;font-weight:600;color:#303133;margin-bottom:10px}", ""]);

// exports
